<template>
  <ul class="list">
    <li class="list_css" v-on:click="itemClick(item.context,item.url,item.id)"
        v-for="item in list" :key="item.id">
      <div class="title_overall_css">
        <div class="help_list_title_css">
          <img src="../../../assets/help/rectangular.png" class="rectangular_css">
          {{ item.title }}
        </div>
        <img alt="arrow" src="../../../assets/help/small_arrow.png" class="help_arrow_css">
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'BackList',
  data () {
    return {
      // 参数
      listId: Number(this.$route.query.listId),
      title: null,
      context: null,
      helpList: {
        common: [
          // 常见问题
          {id: 1001, title: '性别填错了怎么办？'},
          {id: 1002, title: '金币、宝石是什么，怎么获取？'},
          {id: 1003, title: '如何兑换宝石？'},
          {id: 1004, title: '账号为什么被封禁？'},
        ],
        appPlay: [
          // 音柚怎么玩
          {id: 1101, title: '关于“音柚”'},
          {id: 1102, title: '对方喜欢什么样的你'},
          {id: 1103, title: '在“音柚”，有哪些事不能做？'},
        ],
        match: [
          // 偶遇匹配问题
          {id: 1201, title: '声卡怎么玩？'},
          {id: 1202, title: '快速匹配怎么玩？'},
          {id: 1203, title: '相遇怎么玩？'}
        ],
        chat: [
          // 聊天攻略
          {id: 1301, title: '聊天消耗什么？'},
          {id: 1302, title: '聊天内容有隐私保护吗？'},
          {id: 1303, title: '对方不回复我怎么办？'},
          {id: 1304, title: '如何送对方礼物？'},
        ],
        security: [
          // 账号安全
          {id: 1401, title: '如何删除/注销账户？'},
          {id: 1402, title: '被骚扰怎么举报？'}
        ]
      },
      list: Array
    }
  },

  mounted () {
    this.intoList()
  },
  methods: {
    intoList: function () {
      if (this.listId === 1) {
        this.list = []
        this.list = JSON.parse(JSON.stringify(this.helpList.common))
        document.title = '常见问题'
      } else if (this.listId === 2) {
        this.list = []
        this.list = JSON.parse(JSON.stringify(this.helpList.appPlay))
        document.title = '音柚怎么玩'
      } else if (this.listId === 3) {
        this.list = []
        this.list = JSON.parse(JSON.stringify(this.helpList.match))
        document.title = '偶遇匹配问题'
      } else if (this.listId === 4) {
        this.list = []
        this.list = JSON.parse(JSON.stringify(this.helpList.chat))
        document.title = '聊天攻略'
      } else if (this.listId === 5) {
        this.list = []
        this.list = JSON.parse(JSON.stringify(this.helpList.security))
        document.title = '账号安全'
      }
    },
    itemClick: function (context, name, id) {
      this.$router.push({name: 'ContentBack', query: {issueId: id}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/pomelo/app/BackList.vue